import {Fragment, useState, useEffect, useRef} from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { icon } from '@fortawesome/fontawesome-svg-core/import.macro'
import {useGlobalState} from "../../GlobalStateProvider";

const Checkbox: (props: any) => JSX.Element = (props: any) => {

    const input = useRef<HTMLInputElement>(null)
    const [checked, setChecked] = useState<boolean>(false);
    const {children, name, isRadio, defaultValue, setInputIsActive} = props;

    const {state, setState} = useGlobalState();

    const { answers } = state;

    const handleClick = () => {
        if(input && input.current && !isRadio) {

            let updatedAnswers = [...answers, defaultValue];
            if(answers.includes(defaultValue)) {
                updatedAnswers = answers.filter(answer => answer !== defaultValue);
            }
            setState({ ...state, answers: updatedAnswers });

            input.current.click();
        }

        if(input && input.current && isRadio) {
            const answerElements = document.querySelectorAll(`input[name="${name}"]`);
            if(answers) {

                let updatedAnswers = answers;

                for(let i in answerElements) {
                    const answerElement = answerElements[i];
                    if (answerElement instanceof HTMLInputElement) {
                        const value: string = answerElement.value;
                        if(answers.includes(value)) {
                            updatedAnswers = answers.filter(answer => answer !== value);
                        }
                        setState({ ...state, answers: updatedAnswers });
                    }
                }

                updatedAnswers = [...updatedAnswers, input.current.value];
                setState({ ...state, answers: updatedAnswers });
                input.current.click();

                // console.log(state.answers)

            }
        }

    }

    useEffect(() => {
        if(answers.includes(defaultValue)) {
            if(setInputIsActive) {
                setInputIsActive(true)
            }
            setChecked(true);
        }
    }, [answers, setInputIsActive, defaultValue]);

    // useEffect(() => {
    //     if(answers.includes(defaultValue)) {
    //         setChecked(true);
    //     }
    // }, [answers, defaultValue]);

    return (
        <Fragment>
            <button type="button" className="flex flex-row items-center gap-5 md:gap-10 text-start w-[100%]" onClick={() => handleClick()} >
                <div className={`flex items-center justify-center w-[2rem] min-w-[2rem] h-[2rem] md:w-[3rem] md:min-w-[3rem] md:h-[3rem] rounded-full${checked ? ' checkbox-checked' : ' checkbox'}`} >
                    <FontAwesomeIcon icon={icon({name: 'check', style: 'solid'})} size="sm" className="text-white" />
                </div>
                <div className="flex flex-col gap-3 w-[100%]">
                    {children}
                </div>
            </button>
            <input ref={input} type={isRadio ? 'radio' : 'checkbox'} name={name ? name : undefined} checked={checked} className="hidden" value={defaultValue} onChange={() => {} } />
        </Fragment>
    );
}

export default Checkbox;
